export const isKioskUrl = (): boolean => /^\/kiosk-tv\/[^/]+/.test(window.location.pathname);
